// extracted by mini-css-extract-plugin
var _1 = "cBjWe";
var _2 = "vpG08";
var _3 = "bpF0V";
var _4 = "QqfWV";
var _5 = "CGEDf";
var _6 = "KF_g8";
var _7 = "D6UKK";
var _8 = "j7vzC";
var _9 = "pBvf3";
export { _1 as "container", _2 as "copilotIconAndTitle", _3 as "denselessMargin", _4 as "drawerBody", _5 as "drawerContainer", _6 as "drawerHeader", _7 as "headerTitle", _8 as "ssrBackground", _9 as "ssrDarkBackground" }
